enum LogAction {
    ADD,
    EDIT,
    DELETE,
    SAVE_SIMULATION,
    ASSIGN_BARRIERE
}

export default LogAction;
